import React, { Fragment } from "react";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
class AccountLeftSidebar extends React.Component {
  render() {
    const { isAuth, user } = this.props._auth;
    return (
      <Fragment>
        {isAuth && isAuth ? (
          <div className="col-md-3 col-sm-3">
            <div className="bg-cream myacc-left-info h-100 p-3">
              {user && !user.isVendor ? (
                <div>
                  <div className="myacc-info-link">
                    <div>
                      <Link to="/vendor-registeration" className="myacc-link">
                        <span>
                          <img
                            src="https://sundialinsider.s3.us-east-2.amazonaws.com/145recent-view.jpg"
                            width="100%"
                            alt=""
                          />{" "}
                        </span>
                        <span> Become a seller</span>
                      </Link>
                    </div>
                  </div>
                </div>
              ) : (
                <Fragment>
                  <div className="myacc-welcome">
                    <h4 className="welcome-to-acc font-15">Seller Options</h4>
                  </div>
                  <div className="myacc-info-link">
                    <div>
                      <Link to="/seller-dashboard" className="myacc-link">
                        <span>
                          <i className="dashboard-icons fas fa-chart-line"></i>
                        </span>
                        <span>Dashboard</span>
                      </Link>
                    </div>
                  </div>
                  <div className="myacc-info-link">
                    <div>
                      <Link to="/edit-account" className="myacc-link">
                        <span>
                          <i className="dashboard-icons far fa-user-circle"></i>{" "}
                        </span>
                        <span>Seller Profile</span>
                      </Link>
                    </div>
                  </div>
                  <div className="myacc-info-link">
                    <div>
                      <Link to="/seller-orders" className="myacc-link">
                        <span>
                          <i className="dashboard-icons fas fa-luggage-cart"></i>{" "}
                        </span>
                        <span>Orders</span>
                      </Link>
                    </div>
                  </div>

                  <div className="myacc-info-link">
                    <div>
                      <Link to="/seller-products" className="myacc-link">
                        <span>
                          <i className="dashboard-icons fas fa-boxes"></i>{" "}
                        </span>
                        <span>Products</span>
                      </Link>
                    </div>
                  </div>

                  <div className="myacc-info-link">
                    <div>
                      <Link
                        to="/seller-store-information"
                        className="myacc-link"
                      >
                        <span>
                          <i className="dashboard-icons fas fa-store-alt"></i>{" "}
                        </span>
                        <span>Store Information</span>
                      </Link>
                    </div>
                  </div>

                  <div className="myacc-info-link">
                    <div>
                      <Link to="/bulk-products-upload" className="myacc-link">
                        <span>
                          <i className="dashboard-icons fas fa-upload"></i>{" "}
                        </span>
                        <span>Bulk Product Upload</span>
                      </Link>
                    </div>
                  </div>

                  <div className="myacc-info-link">
                    <div>
                      <Link to="/admin-messages" className="myacc-link">
                        <span>
                          <i className="dashboard-icons far fa-comments"></i>{" "}
                        </span>
                        <span>Admin Messages</span>
                      </Link>
                    </div>
                  </div>
                  <div className="myacc-info-link">
                    <div>
                      <Link to="#" target="_blank" className="myacc-link">
                        <span>
                          <i className="dashboard-icons fas fa-user-slash"></i>{" "}
                        </span>
                        <span>
                          <b>Remove as a seller</b>
                        </span>
                      </Link>
                    </div>
                  </div>
                </Fragment>
              )}
            </div>
          </div>
        ) : (
          <div></div>
        )}
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  _auth: state.auth,
});

export default withRouter(connect(mapStateToProps)(AccountLeftSidebar));
